import React from "react";
import { Head, usePage } from "@inertiajs/react";

/**
 * SeoHead
 * -------
 * Renders ONLY the JSON-LD schema blocks from the `seo.schema` Inertia prop.
 * Title, description, OG and Twitter meta tags are already output server-side
 * by the blade template (website.blade.php) from the same `seo` prop, so we
 * intentionally skip them here to avoid duplicate tags.
 *
 * Mounted once in WebsiteLayout — picks up `props.seo.schema` automatically.
 *
 * @param {{ schema?: Array<any> }} props
 */
const SeoHead = ({ schema: schemaOverride = null }) => {
    const { props } = usePage();
    const seo = props.seo || {};

    /** @type {Array<any>} */
    const schemas = schemaOverride || seo.schema || [];

    if (!Array.isArray(schemas) || schemas.length === 0) {
        return null;
    }

    return (
        <Head>
            {schemas.map((schema, i) => (
                <script
                    key={`schema-${i}-${(schema && schema["@type"]) || "item"}`}
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
                />
            ))}
        </Head>
    );
};

export default SeoHead;
